import { useForm } from "react-hook-form";
import Dialog from "../../../atoms/dialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { validateLabel, LabelHelperText, checkNameExist } from "./helpers";
import { useSelector, useDispatch } from "react-redux";
import { getClusterlets } from "../../../../store/constructs/clusterlets/selectors";
import {cloneClusterlet} from "../../../../store/constructs/clusterlets/actions";


const ClonePopUp = ({handleClose,data}) => {

    const { register, control, getValues, reset, trigger, errors } = useForm();
    const dispatch = useDispatch()
    const  clusterlets  = useSelector(getClusterlets);

    const onActionComplete = () => {
        trigger().then(async (isValid) => {
			if (!isValid) return;
			const { title } = getValues();
            const cloneNameExists = checkNameExist(title, clusterlets)
            if(cloneNameExists) {
                return
            } 
			const selectedNode =  clusterlets.find(clusterlet => clusterlet.id === data.id)

			await dispatch(cloneClusterlet({selectedNode, name: title }))

			handleCloseLocal();
		});
    }

    const handleCloseLocal = () => {
        handleClose(false)
    }   

    return (
        <Dialog
            title={"Clone!"}
            handleClose={handleCloseLocal}
            open={true}
            actions={
                <>
                    <Button onClick={handleCloseLocal} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                        Cancel
                    </Button>
                    <Button onClick={onActionComplete} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                        Clone
                    </Button>
                </>
            }
        >
            <TextField
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                required
                label={"Title"}
                placeholder={"Title"}
                variant="outlined"
                name="title"
                error={Boolean(errors.title)}
                helperText={<LabelHelperText control={control} elementTag={"clusterlet"} />}
                inputRef={register({
                    required: true,
                    validate: validateLabel,
                })}
            />
        </Dialog>
    )
}

export default ClonePopUp